import * as t from 'io-ts';

import type { FilterData } from 'portlet/models';

import type { PortletQuery, PortletQueryParams } from '../types';
import { QueryType } from '../modules';

const DatabricksFilterDefaultC = t.union([t.string, t.number]);

export type DatabricksFilterDefault = t.TypeOf<typeof DatabricksFilterDefaultC>;

const DatabricksColumnFilterSettingC = t.partial({
    filter: t.intersection([
        t.type({ listenTo: t.string }),
        t.partial({
            default: DatabricksFilterDefaultC,
            format: t.string,
            whereClause: t.partial({
                columnFunction: t.string,
                valueFunction: t.string,
                operator: t.string,
            }),
        }),
    ]),
});

export type DatabricksColumnFilterSetting = t.TypeOf<typeof DatabricksColumnFilterSettingC>;

const DatabricksQueryColumnC = t.intersection([
    t.type({
        name: t.string,
        type: t.string,
        comment: t.union([t.string, t.null]),
        drillable: t.boolean,
    }),
    DatabricksColumnFilterSettingC,
]);

export type DatabricksQueryColumn = t.TypeOf<typeof DatabricksQueryColumnC>;

const DatabricksQueryTableC = t.type({
    name: t.string,
    columns: t.array(DatabricksQueryColumnC),
});

export const DatabricksOrderC = t.union([t.literal('ASC'), t.literal('DESC')]);
export type DatabricksOrder = t.TypeOf<typeof DatabricksOrderC>;

export type DatabricksQueryTable = t.TypeOf<typeof DatabricksQueryTableC>;

const DatabricksConditionC = t.partial({
    condition: t.partial({
        allowChangeOrder: t.boolean,
        maxLimit: t.number,
        fields: t.array(t.string),
    }),
});
export type DatabricksCondition = t.TypeOf<typeof DatabricksConditionC>;

export const DatabricksQueryC = t.intersection([
    t.type({
        type: t.literal('Databricks'),
        statement: t.string,
        environment: t.string,
        warehouseId: t.string,
        tables: t.array(DatabricksQueryTableC),
    }),
    t.partial({
        drill: t.type({
            allowMultiple: t.boolean,
        }),
    }),
    DatabricksConditionC,
]);

export type DatabricksQuery = t.TypeOf<typeof DatabricksQueryC>;

export interface DatabricksParameters {
    statement: string;
    metadata: DatabricksQuery;
    filters: FilterData[];
}

export const isDatabricksQuery = (query: PortletQuery): query is DatabricksQuery =>
    query.type === QueryType.Databricks;

export const areDatabricksQueryParameters = (
    query: PortletQueryParams,
): query is DatabricksParameters => query.metadata.type === 'Databricks';
